// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.layout-body {
  display: flex;
  flex-grow: 1;
}

.sidebar {
  transition: width 0.3s ease;
  overflow: hidden;
}

.sidebar.open {
  width: 250px; /* Adjust sidebar width */
}

.sidebar.closed {
  width: 0;
}

.main-body {
  flex-grow: 1;
  padding: 20px;
}

/* pdf css */

@media (max-width: 576px) {
  .content {
    width: 100% !important;
    padding: 0 10px;
  }

  input  {
    width: 100%  ;
  }
  select {
    width: 100%  !important;
  }
}


#mobile-products-sidebar   input[type='checkbox'] {
    width: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/style/layout.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,YAAY,EAAE,yBAAyB;AACzC;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA,YAAY;;AAEZ;EACE;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;EACzB;AACF;;;AAGA;IACI,WAAW;AACf","sourcesContent":[".layout-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.layout-body {\n  display: flex;\n  flex-grow: 1;\n}\n\n.sidebar {\n  transition: width 0.3s ease;\n  overflow: hidden;\n}\n\n.sidebar.open {\n  width: 250px; /* Adjust sidebar width */\n}\n\n.sidebar.closed {\n  width: 0;\n}\n\n.main-body {\n  flex-grow: 1;\n  padding: 20px;\n}\n\n/* pdf css */\n\n@media (max-width: 576px) {\n  .content {\n    width: 100% !important;\n    padding: 0 10px;\n  }\n\n  input  {\n    width: 100%  ;\n  }\n  select {\n    width: 100%  !important;\n  }\n}\n\n\n#mobile-products-sidebar   input[type='checkbox'] {\n    width: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
